<template>
    <section class="container">
        <h2 class="pb-6">Our Strengths</h2>
        <div>
            <p class="dark-text">
                CGH is uniquely positioned to support your transportation and land development initiative 
                and have years of experience and professional accreditation to undertake all 
                required activities. Some of our key strengths include:
            </p>
            <ul class="custom-list">
                <li>Licensed professional engineers, permitted to practice in the province of Ontario</li>
                <li>RAQs qualified for preparing traffic impact studies within the Ministry of Transportation Ontario's (MTO's) permit control area</li>
                <li>65+ years of professional engineering experience</li>
                <li>A large team of traffic analysts and designers to handle projects large and small</li>
            </ul>
        </div>
    </section>
</template>